"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAuditResponseSchema = exports.AdminAuditQuerySchema = exports.AdminAuditEntrySchema = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
exports.AdminAuditEntrySchema = zod_1.z.object({
    id: zod_1.z.string(),
    actor: zod_1.z.enum(['user', 'system', 'ops']),
    action: zod_1.z.string(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    ip: zod_1.z.string().nullable(),
    createdAt: zod_1.z.iso.datetime(),
    userId: zod_1.z.uuid().nullable(),
    staff: zod_1.z.object({ id: zod_1.z.uuid(), name: zod_1.z.string() }).nullable(),
});
exports.AdminAuditQuerySchema = common_1.CursorQuerySchema.extend({
    staffId: zod_1.z.uuid().optional(),
    action: zod_1.z.string().min(1).max(100).optional(),
    /** Only entries whose metadata names this exchange (`exchange.refreshed` records it). */
    exchangeId: zod_1.z.uuid().optional(),
});
exports.AdminAuditResponseSchema = (0, common_1.pageSchema)(exports.AdminAuditEntrySchema);
//# sourceMappingURL=audit.js.map